import { Connection } from './connection';
import { CoordinatorService } from './coordinator.service';
import { ScriptBase } from './script-base';
import { ScriptHitset } from './script-hitset';
import { XItem } from './x-item';

export class ScriptResource extends ScriptBase {
    #coords: CoordinatorService;
    #connection: Connection;

    constructor(coords: CoordinatorService, _connection: Connection) {
        super(coords, _connection);
        this.#coords = coords;
        this.#connection = _connection;
    }

    get target() {
        return this.#connection;
    }

    get xitemLs() {
        return this.#connection.xitemLs.map((x) => x.scriptClass);
    }

    get idLs() {
        return this.#connection.xitemLs.map((x) => x.id);
    }

    json() {
        return this.#connection.json();
    }
    on() {
        this.#connection.isOn = true;
    }

    off() {
        this.#connection.isOn = false;
    }

    hitset(isPreview = false) {
        const nH = new ScriptHitset(this.#coords, isPreview);
        return this._hitset(nH, this.#connection.idSet, true);
    }

    add(arg: { [key: string]: any }) {
        arg['id'] = arg['id'] || this.#coords.uniqueId();
        const xitem = new XItem(this.#coords, arg);
        this.#connection.readXItemList([xitem]);
        this.#connection.isOn = true; // force preview recalc
    }

    log(prefix: 'Resource') {
        console.log(`${prefix}: ${this.#connection.title} SIZE: ${this.#connection.size}`);
        return this;
    }

    display() {
        const stg = this.#coords.script$.stage('databin');
        stg?.display();
        this.#connection.databin?.setCurrent();
        return this;
    }

    test(t: string | RegExp) {
        if (t instanceof RegExp) return t.test(this.#connection.title);
        else {
            t = t.trim().toLowerCase();
            return this.#connection.title.toLowerCase().includes(t);
        }
    }
}
